export default __webpack_public_path__ + "static/media/pptxThumbnail.426d73e7.svg";